import { any, string } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import OnboardingListItem from "../OnboardingListItem/OnboardingListItem";
import style from "../ReadingListDownload/styles.module.scss";
import { getSwissportForm } from "../../api/profileApi";
import { forceDownload } from "../../containers/ResourceFolders/util";

const SwissportOnboarding = ({ appData, swissportLoading }) => {
  const { swissportOnboarding } = {
    ...{ swissportOnboarding: {} },
    ...appData,
  };
  const EHQSubmitted =
    swissportOnboarding && swissportOnboarding.employerHealthQuestionnaire;
  const FiveYHSubmitted =
    swissportOnboarding && swissportOnboarding.fiveYearHistory;
  const PIFSubmitted =
    swissportOnboarding && swissportOnboarding.personalInformationForm;
  const IRFSubmitted =
    swissportOnboarding && swissportOnboarding.informationReleaseForm;

  const handleClick = (form) => {
    if (form === "5YCH") {
      return getSwissportForm("Swissport 5YCH").then((response) =>
        forceDownload(response, "Swissport 5YCH")
      );
    }
    if (form === "PIF") {
      return getSwissportForm("Swissport PIF").then((response) =>
        forceDownload(response, "Swissport PIF")
      );
    }
    if (form === "EHQ") {
      return getSwissportForm("Swissport EHQ").then((response) =>
        forceDownload(response, "Swissport EHQ")
      );
    }
    if (form === "IRF") {
      return getSwissportForm("Swissport IRF").then((response) =>
        forceDownload(response, "Swissport IRF")
      );
    }
    return null;
  };

  return (
    <div className="container text-bluishGray pb-2">
      <header className="row">
        <div className="col-12">
          <h2 className="section-header pt-2">Swissport Onboarding</h2>
        </div>
      </header>
      <div className="row">
        <div className="col-lg-6">
          <div
            className={`${style.readingList__wrapper} section-body pt-1 bg-white`}
          >
            <h5 className="px-1">Forms</h5>
            <OnboardingListItem
              title="5 Year Checkable Employment History"
              status={FiveYHSubmitted ? 3 : 1}
              btnText="Complete"
              handleClick={() => handleClick("5YCH")}
              url={`/profile/edit/swissport-onboarding/FiveYearHistory`}
              supportDownload={true}
              loading={swissportLoading === "fiveYearHistory" && true}
            />
            <OnboardingListItem
              title="Employee Health Questionnaire"
              status={EHQSubmitted ? 3 : 1}
              btnText="Complete"
              handleClick={() => handleClick("EHQ")}
              url={`/profile/edit/swissport-onboarding/EmployeeHealthQuestionnaire`}
              supportDownload={true}
              loading={
                swissportLoading === "employerHealthQuestionnaire" && true
              }
            />
            <OnboardingListItem
              title="Information Release Form"
              status={IRFSubmitted ? 3 : 1}
              btnText="Complete"
              handleClick={() => handleClick("IRF")}
              url={`/profile/edit/swissport-onboarding/InformationReleaseForm`}
              supportDownload={true}
              loading={swissportLoading === "informationReleaseForm" && true}
            />
            <OnboardingListItem
              title="Personal Information Form"
              status={PIFSubmitted ? 3 : 1}
              btnText="Complete"
              handleClick={() => handleClick("PIF")}
              url={`/profile/edit/swissport-onboarding/PersonalInformationForm`}
              supportDownload={true}
              loading={swissportLoading === "personalInformationForm" && true}
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className={`${style.readingList__wrapper} section-body pt-1 bg-white`}
          >
            <h5 className="px-1">Basic DBS Information</h5>
            <p className="px-1">
              A DBS check is required for the job role you applied for. Please
              click on the link below and complete the form to enable HRGO to
              complete a DBS check.
            </p>
            <div
              style={{
                with: "100%",
                display: "flex",
                justifyContent: "flex-end",
                padding: "1rem",
              }}
            >
              <a
                href="https://forms.office.com/Pages/ResponsePage.aspx?id=bF43RFTuvUGKgS0U9GKUztDCA2HJiIpHsdJGOi34cPhUNzIxS0lXRDNQQzRNSlY5OEpPNEJFSFE0SiQlQCN0PWcu"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary ml-sm-1 mt-hf mt-sm-0 styles__onboarding__btn___3so8L"
              >
                DBS Form
              </a>
            </div>
          </div>
        </div>
        <div className="w-100 d-flex justify-content-end mt-2">
          <Link to="/profile" className="btn btn-primary px-3">
            Back to My Account
          </Link>
        </div>
      </div>
    </div>
  );
};

SwissportOnboarding.propTypes = {
  appData: any,
  swissportLoading: string,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  swissportLoading: state.core.swissport.isLoading,
});

const withRedux = connect(mapStateToProps, null);

export default withRedux(SwissportOnboarding);
